import type { AnnotationIslandView } from './interaction-state-machine'

export const ANNOTATION_COMPACT_ISLAND_AUTO_DISMISS_MS = 8_000

/**
 * Compact selection affordances should disappear once the browser selection is
 * gone. Confirm flows keep their semantic selection in reducer state and
 * intentionally survive transient DOM selection clears.
 */
export function shouldDismissAnnotationIslandOnEmptySelection(view: AnnotationIslandView): boolean {
  return view === 'compact'
}

/**
 * The compact CTA is ephemeral by design, so auto-dismiss it after a short
 * delay. Confirm flows stay open to avoid discarding user intent or input.
 */
export function getAnnotationIslandAutoDismissMs(view: AnnotationIslandView): number | null {
  return view === 'compact' ? ANNOTATION_COMPACT_ISLAND_AUTO_DISMISS_MS : null
}
